// extracted by mini-css-extract-plugin
export default {"artwork":"LDFAcYc48yQLZhP6mIyB"};